import useWindowSize from 'hooks/useWindowSize'

const useIsMobileDevice = () => {
  const [screenWidth] = useWindowSize()

  return screenWidth <= 768
}

export default useIsMobileDevice
